// Auth Actions
export const AUTH_SIGN_IN_INIT = 'AUTH/SIGN_IN_INIT';
export const AUTH_SIGN_IN_SUCCESS = 'AUTH/SIGN_IN_SUCCESS';
export const AUTH_SIGN_IN_FAILED = 'AUTH/SIGN_IN_FAILED';
export const AUTH_SIGN_UP_INIT = 'AUTH/SIGN_UP_INIT';
export const AUTH_SIGN_UP_SUCCESS = 'AUTH/SIGN_UP_SUCCESS';
export const AUTH_SIGN_UP_FAILED = 'AUTH/SIGN_UP_FAILED';
export const AUTH_RESET_PASSWORD_INIT = 'AUTH/RESET_PASSWORD_INIT';
export const AUTH_SET_PROCEEDING_STATUS = 'AUTH/SET_PROCEEDING_STATUS';
export const AUTH_STRIPE_CONNECT_INIT = 'AUTH/STRIPE_CONNECT_INIT';
export const AUTH_STRIPE_CONNECT_SUCCESS = 'AUTH/STRIPE_CONNECT_SUCCESS';
export const AUTH_STRIPE_CONNECT_FAILED = 'AUTH/STRIPE_CONNECT_FAILED';
export const AUTH_SIGN_OUT = 'AUTH/SIGN_OUT';
export const AUTH_VERIFY_EMAIL_INIT = 'AUTH/VERIFY_EMAIL_INIT';
export const AUTH_VERIFY_EMAIL_SUCCESS = 'AUTH/VERIFY_EMAIL_SUCCESS';
export const AUTH_VERIFY_EMAIL_FAILED = 'AUTH/VERIFY_EMAIL_FAILED';
export const AUTH_IMPERSONATE_INIT = 'AUTH/IMPERSONATE_INIT';
export const AUTH_IMPERSONATE_FINISHED = 'AUTH/IMPERSONATE_FINISHED';

// Course Actions
export const FETCH_COURSES_INIT = 'COURSE/FETCH_COURSES_INIT';
export const FETCH_COURSES_SUCCESS = 'COURSE/FETCH_COURSES_SUCCESS';
export const FETCH_COURSES_FAILED = 'COURSE/FETCH_COURSES_FAILED';
export const COURSE_SELECT = 'COURSE/SELECT_COURSE';
export const COURSE_NEXT_LESSON = 'COURSE/NEXT_LESSON';
export const COURSE_PREV_LESSON = 'COURSE/PREV_LESSON';
export const COURSE_SELECT_LESSON = 'COURSE/SELECT_LESSON';
export const COURSE_COMPLETE_LESSON = 'COURSE/COMPLETE_LESSON';
export const ADD_POST_INIT = 'FORUM/ADD_POST_INIT';
export const ADD_POST_SUCCESS = 'FORUM/ADD_POST_SUCCESS';
export const ADD_POST_FAILED = 'FORUM/ADD_POST_FAILED';
export const FETCH_FORUM_INIT = 'FORUM/FETCH_FORUM_INIT';
export const FETCH_FORUM_SUCCESS = 'FORUM/FETCH_FORUM_SUCCESS';
export const FETCH_FORUM_FAILED = 'FORUM/FETCH_FORUM_FAILED';
export const FETCH_TERMS_INIT = 'GLOSSARY/FETCH_TERMS_INIT';
export const FETCH_TERMS_SUCCESS = 'GLOSSARY/FETCH_TERMS_SUCCESS';
export const FETCH_TERMS_FAILED = 'GLOSSARY/FETCH_TERMS_FAILED';
export const SET_COURSE_ERROR = 'COURSE/SET_COURSE_ERROR';

// User Actions
export const UPDATE_USER_INIT = 'USER/UPDATE_USER_INIT';
export const UPDATE_USER_SUCCESS = 'USER/UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILED = 'USER/UPDATE_USER_FAILED';

// Admin Actions
export const ADMIN_START_IMPERSONATE = 'ADMIN/START_IMPERSONATE';
export const ADMIN_END_IMPERSONATE = 'ADMIN/END_IMPERSONATE';
